const MEETING_UPDATED_EVENT = 'poneva:meeting-updated';

export function announceMeetingUpdated() {
  window.dispatchEvent(new Event(MEETING_UPDATED_EVENT));
}

export function subscribeMeetingUpdates(listener: () => void) {
  window.addEventListener(MEETING_UPDATED_EVENT, listener);
  return () => window.removeEventListener(MEETING_UPDATED_EVENT, listener);
}
